import Typography from "@material-ui/core/Typography";
import { IsInfinite } from "gatsby-theme-rpsych-cohend/src/components/content/IsInfinite";
import * as React from 'react';
export default {
  Typography,
  IsInfinite,
  React
};